import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { CardHeader, useMediaQuery } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Button from './Buttons/CustomButton';
import DataDistributionBar from './DataDistributionBar';
import Grid from '@material-ui/core/Grid';
import ChipWithTooltip from './ChipWithTooltip';
import InsightsDrawer from '../Dashboard/ElevationDashboardV2/components/drawer/InsightsDrawer';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        height: '100%',
        width: '100%',
        boxShadow: 'none',
        borderColor: 'hsl(219 100 93)',
        borderRadius: '.75rem',
        border: '1px solid',
        padding: 0,
        '& .MuiTypography-h5': {
            marginTop: theme.spacing(2)
        }
    },
    headerContent: {
        padding: theme.spacing(0, 2),
        justifyContent: 'center',
    },
    contentWithButton: {
        '&:last-child': {
            paddingBottom: theme.spacing(2),
        },
        '& > div': {
            [theme.breakpoints.up('sm')]: {
                flexDirection: 'row',
                height: '100%',
            },
            alignItems: 'flex-start'
        },
        '& button': {
            fontWeight: 'bold',
            borderRadius: '0.5rem',
        },
        [theme.breakpoints.down('sm')]: {
            paddingRight: theme.spacing(2),
            paddingLeft: theme.spacing(2),
        },
    },
    gridItem: {
        [theme.breakpoints.up('md')]: {
            paddingRight: theme.spacing(2),
        },

        [theme.breakpoints.down('sm')]: {
            paddingBottom: theme.spacing(1.5),
        },
    },
    title: {
        padding: 0,
        margin: 0
    },
    cardHeaderContentTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            '& .MuiChip-root': {
                margin: `${theme.spacing(1)}px 0px 0px 0px`
            },
        },
    },
    subheader: {
        marginTop: 0,
        marginBottom: theme.spacing(2),
    },
    buttonGridItem: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            justifyContent: 'flex-end',
        }
    },
    exploreButton: {
        [theme.breakpoints.up('md')]: {
            marginRight: theme.spacing(1)
        }
    },
}))

const DataDistributionCard = (props) => {
    const classes = useStyles()
    const isNarrowLg = useMediaQuery('(min-width:1280px) and (max-width:1360px)')
    const isNarrowMd = useMediaQuery('(min-width:960px) and (max-width:1015px)')

    const { title, subheader, dataDistributionSections, isPositiveMetric, showLegend, tooltipDescription, tooltipTitle, helpdocLink, insightsDrawerButtonLink, industryBreakdown = null, reviewCount } = props

    const [drawerOpened, setDrawerOpened] = useState(false)

    const toggleDrawer = (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }

        setDrawerOpened(!drawerOpened)
    }

    return (
        <Grid item xs={12}>
            <Card className={classes.root}>
                <CardHeader
                    title={
                        <div className={classes.cardHeaderContentTitle}>
                            <Typography variant="h6" className={classes.title}>{title}</Typography>
                            {isPositiveMetric !== undefined &&
                                <ChipWithTooltip
                                    tooltipDescription={tooltipDescription}
                                    tooltipTitle={tooltipTitle}
                                />
                            }
                        </div>
                    }
                    subheader={<Typography className={classes.subheader} variant="body2">{subheader}</Typography>}
                    className={classes.headerContent}
                />
                <CardContent className={classes.contentWithButton}>
                    <Grid container justify="center">
                        <Grid item xl={10} lg={isNarrowLg ? 9 : 10} md={isNarrowMd ? 8 : 9} sm={12} xs={12} className={classes.gridItem}>
                            <DataDistributionBar isPositiveMetric={isPositiveMetric} sections={dataDistributionSections} showLegend={showLegend}/>
                        </Grid>
                        <Grid item xl={2} lg={isNarrowLg ? 3 : 2} md={isNarrowMd ? 4 : 3} sm={12} xs={12} className={classes.buttonGridItem}>
                            <Button color="tertiary" variant="contained" className={classes.exploreButton} onClick={toggleDrawer}>
                                Explore insights
                            </Button>
                            <InsightsDrawer
                                helpdocLink={helpdocLink}
                                title={title}
                                drawerOpened={drawerOpened}
                                toggleDrawer={toggleDrawer}
                                insightsDrawerButtonLink={insightsDrawerButtonLink}
                                industryBreakdown={industryBreakdown}
                                reviewCount={reviewCount}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    )
}

export default (DataDistributionCard)
